'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var CIRCLE_SIZE = '20px';
var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 34px;\n  height: ", ";\n\n  ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 34px;\n  height: ", ";\n\n  ",
    ";\n"])), CIRCLE_SIZE, function (_a) {
    var disabled = _a.disabled;
    return disabled && "\n    opacity: .5\n  ";
});
var StyledInput = styled__default.input(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  appearance: none;\n  width: 100%;\n  height: 14px;\n  background: ", ";\n  border-radius: 7px;\n  position: relative;\n  outline: 0;\n  margin: 0;\n  cursor: pointer;\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: -1px;\n    transform: translateY(-50%);\n    transition: all .3s;\n    width: ", ";\n    height: ", ";\n    background: ", ";\n    border-radius: 50%;\n    box-shadow: ", ";\n  }\n\n  &:checked {\n    background-color: ", "61;\n\n    &:before {\n      left: calc(100% - ", " + 1px);\n      background-color: ", ";\n    }\n  }\n\n  &:disabled {\n   cursor: not-allowed;\n  }\n}\n"], ["\n  appearance: none;\n  width: 100%;\n  height: 14px;\n  background: ", ";\n  border-radius: 7px;\n  position: relative;\n  outline: 0;\n  margin: 0;\n  cursor: pointer;\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: -1px;\n    transform: translateY(-50%);\n    transition: all .3s;\n    width: ", ";\n    height: ", ";\n    background: ", ";\n    border-radius: 50%;\n    box-shadow: ", ";\n  }\n\n  &:checked {\n    background-color: ", "61;\n\n    &:before {\n      left: calc(100% - ", " + 1px);\n      background-color: ", ";\n    }\n  }\n\n  &:disabled {\n   cursor: not-allowed;\n  }\n}\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
}, CIRCLE_SIZE, CIRCLE_SIZE, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.depth_4;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryAlt;
}, CIRCLE_SIZE, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
});
var Switch = function (_a) {
    var _b = _a.checked, checked = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.required, required = _d === void 0 ? false : _d, rest = tslib_es6.__rest(_a, ["checked", "disabled", "required"]);
    return (React__default.createElement(Container, { disabled: disabled },
        React__default.createElement(StyledInput, tslib_es6.__assign({ type: "checkbox", checked: checked, required: required, disabled: disabled }, rest))));
};
var templateObject_1, templateObject_2;

exports.Switch = Switch;
